function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8C0 7.44772 0.447715 7 1 7H47C47.5523 7 48 7.44772 48 8C48 8.55228 47.5523 9 47 9H0.999999C0.447714 9 0 8.55228 0 8Z",
  fill: "#EAEEF4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 18.3334,
  y: 14.332,
  width: 36,
  height: 2,
  rx: 1,
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118 45.875C118 45.3918 118.392 45 118.875 45H165.125C165.608 45 166 45.3918 166 45.875C166 46.3582 165.608 46.75 165.125 46.75H118.875C118.392 46.75 118 46.3582 118 45.875Z",
  fill: "#EAEEF4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113 51.125C113 50.6418 113.392 50.25 113.875 50.25H142.125C142.608 50.25 143 50.6418 143 51.125C143 51.6082 142.608 52 142.125 52H113.875C113.392 52 113 51.6082 113 51.125Z",
  fill: "#EAEEF4"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 79,
  cy: 87.5,
  rx: 60,
  ry: 9.5,
  fill: "#F5F8FA"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 17,
  r: 17,
  fill: "#EAEEF4"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.5,
  cy: 35.5,
  r: 11.5,
  fill: "#EAEEF4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.7679 20.6337C71.0554 19.1638 69.2391 18.5279 67.7111 19.2133C66.1832 19.8987 65.5221 21.6458 66.2346 23.1157L68.148 27.0627C61.8302 28.7813 55.868 32.0322 50.8955 36.8154C49.7015 37.9639 49.7015 39.8261 50.8955 40.9746C52.0895 42.1232 54.0253 42.1232 55.2193 40.9746C59.6765 36.687 65.0736 33.8545 70.7726 32.4771L73.3917 37.88C67.9284 38.9039 62.7127 41.4512 58.4809 45.5219C57.2869 46.6704 57.2869 48.5326 58.4809 49.6811C59.6749 50.8296 61.6107 50.8296 62.8047 49.6811C66.531 46.0966 71.2246 44.0095 76.0773 43.42L78.8378 49.1146C74.2131 49.1321 69.594 50.8379 66.0654 54.2322C64.8715 55.3807 64.8715 57.2429 66.0654 58.3914C67.2594 59.54 69.1952 59.54 70.3892 58.3914C73.4983 55.4006 77.8839 54.3859 81.8591 55.3473L86.2311 64.3663C86.9436 65.8362 88.7599 66.4721 90.2879 65.7867C91.8158 65.1013 92.4769 63.3542 91.7644 61.8843L71.7679 20.6337ZM87.1584 38.4995L91.0814 46.5924C92.5106 47.4552 93.8621 48.4847 95.1058 49.6811C96.2998 50.8296 98.2356 50.8296 99.4296 49.6811C100.624 48.5326 100.624 46.6704 99.4296 45.5219C95.8852 42.1124 91.6506 39.7716 87.1584 38.4995ZM80.9354 25.6622L83.9336 31.8471C90.8307 32.8257 97.4723 35.8682 102.781 40.9746C103.975 42.1232 105.911 42.1232 107.105 40.9746C108.298 39.8261 108.298 37.9639 107.105 36.8154C99.836 29.8236 90.4528 26.1058 80.9354 25.6622Z",
  fill: "url(#paint0_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 21,
  y1: 42.5,
  x2: 67.1271,
  y2: 99.2718,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgCrossedWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 97,
    viewBox: "0 0 166 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = React.forwardRef(SvgCrossedWifi);
export default __webpack_public_path__ + "static/media/crossed-wifi.24ec93ec.svg";
export { ForwardRef as ReactComponent };